import type { QueueCard } from "../api";
import { Card, toCardView, type CardAction } from "./Card";

/**
 * The top strip of the daily choreography: clear the queue, scan the table,
 * leave. Horizontal rail so the count is visible without scrolling the page.
 */
export function ActionQueue({
  cards,
  errors,
  busyId,
  onAct,
  sweepNote,
}: {
  cards: QueueCard[];
  errors: Record<string, string>;
  busyId: string | null;
  onAct: (id: string, action: CardAction) => void;
  sweepNote?: string;
}) {
  const pending = cards.filter((c) => c.status === "pending" || c.status === "snoozed");

  return (
    <section id="queue" style={{ padding: "34px 0 0", scrollMarginTop: 76 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 11, flexWrap: "wrap" }}>
        <h2>Action queue</h2>
        <span
          className="num"
          style={{
            fontSize: 11,
            color: pending.length ? "var(--warn)" : "var(--text-faint)",
            background: pending.length ? "var(--warn-bg)" : "var(--muted-bg)",
            borderRadius: 10,
            padding: "3px 9px",
          }}
        >
          {pending.length}
        </span>
        <span style={{ flex: 1 }} />
        <span style={{ fontSize: 12.5, color: "var(--text-faint)" }}>
          Nothing changes spend without your tap.
        </span>
      </div>

      <div className="queue-rail">
        {cards.map((c) => (
          <div key={c.id}>
            <Card card={toCardView(c)} onAct={onAct} busy={busyId === c.id} />
            {errors[c.id] && (
              <div
                className="card-attrib"
                style={{ color: "var(--neg)", padding: "8px 4px 0", whiteSpace: "normal" }}
              >
                {errors[c.id]}
              </div>
            )}
          </div>
        ))}

        {cards.length === 0 && (
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: 7,
              justifyContent: "center",
              background: "var(--surface)",
              border: "1px dashed var(--border-strong)",
              borderRadius: 12,
              padding: 24,
              minHeight: 148,
            }}
          >
            <div style={{ fontSize: 14.5, fontWeight: 500 }}>Queue clear.</div>
            <div style={{ fontSize: 12.5, color: "var(--text-4)" }}>
              {sweepNote ?? "Keeper is gathering data."}
            </div>
          </div>
        )}
      </div>
    </section>
  );
}
